import { redirect, RouteObject } from 'react-router-dom'
import axios from 'axios'
import { base_url } from 'env'
import ActivitiesPage from 'pages/Activities/Activities'
import ActivityCreationPage from 'pages/Activities/ActivityCreate'
import ActivityPreviewPage from 'pages/Activities/ActivityPreview'
import ActivityEditPage from 'pages/Activities/ActivityEdit'

export const ActivityRoutes: RouteObject[] = [
  {
    path: 'activities', // Use relative path
    loader: async () => {
      try {
        const response = await axios.get(base_url + '/activity/')
        return response.data
      } catch (error) {
        console.log(error)
        return [] // Return empty data on error
      }
    },
    element: <ActivitiesPage />,
  },
  {
    path: 'activity',
    element: <ActivityCreationPage />,
  },
  {
    path: 'activity/:id', // Use relative path
    loader: async ({ params }) => {
      try {
        const response = await axios.get(base_url + `/activity/${params.id}`)
        return response.data
      } catch (error) {
        console.log(error)
        return redirect('/activities')
      }
    },
    element: <ActivityPreviewPage />,
  },
  {
    path: 'activity/:id/edit', // Use relative path
    loader: async ({ params }) => {
      try {
        const response = await axios.get(base_url + `/activity/${params.id}`)
        return response.data
      } catch (error) {
        console.log(error)
        return redirect('/activities')
      }
    },
    element: <ActivityEditPage />,
  },
]
